import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { defaultMeta, TTechnologiesValues } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	technology: TSelectOptionType<TTechnologiesValues> | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	technology: null,
};

const sectors = createSlice({
	name: 'sectors',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setTechnology: (state, action: PayloadAction<{
			technology: TSelectOptionType<TTechnologiesValues> | null;
		}>) => {
			state.technology = action.payload.technology;
			state.page = initialState.page;
		},
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setTechnology,
} = sectors.actions;

export default sectors.reducer;
